module.exports = __webpack_public_path__ + "img/op_pull.93ad450d.svg";